export const environment = {
    production: false,
    staging: false,
    hotfix: true,
    name: 'hotfix',
    APIEndpoint: 'https://{0}.doctor-clinix.com/api/',
    APIEndpoint2: 'http://{0}.doctor-clinix.com:5000/api/',
    openReplayKey: "KIHM3kcIokNLsSDZtgA4",
    openReplayIngestPoint: 'https://openreplay.doctor-clinix.com/ingest',
    isOpenReplayEnabled: true,
    version: '1.0.116501'
  };
